"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gameHeight_1 = __importDefault(require("../../constants/gameHeight"));
const ZIndexType_1 = __importDefault(require("../../enums/ZIndexType"));
const state_1 = __importDefault(require("../../state"));
const getTilemap_1 = __importDefault(require("../definables/getTilemap"));
const isClawOnCooldown_1 = __importDefault(require("../isClawOnCooldown"));
const isCootsInObstacle_1 = __importDefault(require("../isCootsInObstacle"));
const drawImage_1 = __importDefault(require("./drawImage"));
const drawInteractHUD = () => {
    const destructible = (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getDestructibleWithinRange();
    const canDestroy = destructible !== null;
    const hardZIndex = {
        value: 10002,
        type: ZIndexType_1.default.Hard
    };
    const width = 36;
    const height = 30;
    const offset = 4;
    const sourceX = (((0, isCootsInObstacle_1.default)() || (0, isClawOnCooldown_1.default)())
        ? width * 2
        : 0) + (canDestroy
        ? 0
        : width);
    (0, drawImage_1.default)("interact-hud", 1, sourceX, 0, width, height, offset, gameHeight_1.default - height - offset, width, height, hardZIndex);
};
exports.default = drawInteractHUD;
